export const contactEmail = 'info@healingals.org';

export const mailto = `mailto:${contactEmail}`;
